// extracted by mini-css-extract-plugin
module.exports = {"main":"ProcessBanner-module--main--2Kv1E","title":"ProcessBanner-module--title--1pbRG","step":"ProcessBanner-module--step--1I6IB"};